import { RewardType } from 'root/src/shared/rewards/constants';
export const getProductAmount = (product) => {
    if (!product) {
        return 0;
    }
    if (product.type === RewardType.CUSTOM) {
        return Infinity;
    }
    return product.productsAvailable || 0;
};
